import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PaginatorModule } from 'primeng/paginator';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SuccessToasterComponent } from './components/success-toaster/success-toaster.component';
import { ErrorToasterComponent } from './components/error-toaster/error-toaster.component';
import { CommonButtonComponent } from './components/common-button/common-button.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { TextFormatPipe } from './pipes/text-format.pipe';
import { HeaderComponent } from './components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CommonIconComponent } from './components/common-icon/common-icon.component';
import { InputFiledComponent } from './components/input-filed/input-filed.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { TextAreaComponent } from './components/text-area/text-area.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { EsignUploadOverlayComponent } from './components/esign-upload-overlay/esign-upload-overlay.component';
import { AddCreditsModalComponent } from './components/add-credits-modal/add-credits-modal.component';
import { ListHeaderComponent } from './components/list-header/list-header.component';


@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule,
        InfiniteScrollDirective,
        FontAwesomeModule,
        SuccessToasterComponent,
        ErrorToasterComponent,
        CommonButtonComponent,
        SpinnerComponent,
        SafeUrlPipe,
        TextFormatPipe,
        HeaderComponent,
        NgSelectModule,
        SidebarComponent,
        InputFiledComponent,
        CommonIconComponent,
        CheckboxComponent,
        TextAreaComponent,
        DropdownComponent,
        PaginatorComponent,
        NavbarComponent,
        EsignUploadOverlayComponent,
        AddCreditsModalComponent,
        ListHeaderComponent
    ],
    declarations: [
    SuccessToasterComponent,
    ErrorToasterComponent,
    CommonButtonComponent,
    SpinnerComponent,
    SafeUrlPipe,
    TextFormatPipe,
    HeaderComponent,
    SidebarComponent,
    CommonIconComponent,
    InputFiledComponent,
    CheckboxComponent,
    TextAreaComponent,
    DropdownComponent,
    PaginatorComponent,
    NavbarComponent,
    EsignUploadOverlayComponent,
    AddCreditsModalComponent,
    ListHeaderComponent
  ],
    imports: [
       CommonModule,
       FormsModule,
       ReactiveFormsModule,
       RouterModule,
       NgbModule,
       InfiniteScrollDirective,
       FontAwesomeModule,
       NgSelectModule,
       PaginatorModule,
    ],
    providers: [
    ],
})
export class SharedModule { }